<template>
  <v-dialog v-model="show" max-width="950px">
    <form-toolbar title="Cargo Handling"
                  :showSubmitButton="false"
                  :onCloseClick="onCloseClick" />
    <v-card class="pa-1">
      <div v-if="!error" class="d-flex">
        <div class="ml-auto">
          <v-tabs v-model="tab" icons-and-text>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#outbound"
                   v-if="outboundCargo">
              Outbound
              <span>
                <v-icon right>mdi-ferry</v-icon>
                <v-icon right>mdi-arrow-left</v-icon>
              </span>
            </v-tab>

            <v-tab href="#inbound"
                   v-if="inboundCargo">
              Inbound
              <span>
                <v-icon right>mdi-ferry</v-icon>
                <v-icon right>mdi-arrow-right</v-icon>
              </span>
            </v-tab>
          </v-tabs>
        </div>
      </div>

      <v-tabs-items v-if="!error" v-model="tab">
        <v-tab-item value="outbound">
          <cargo-table :cargoLines="outboundCargo"
                       :activity="activity"
                       :isOutbound="true"/>
        </v-tab-item>
        <v-tab-item value="inbound">
          <cargo-table
                       :cargoLines="inboundCargo"
                       :activity="activity"
                       :isOutbound="false"/>
        </v-tab-item>
      </v-tabs-items>

      <v-row v-if="error" class="pa-4" justify="center">
        <v-alert outlined type="warning"> No matching voyage found in Flow, please contact your shipping/logistics team. </v-alert>
      </v-row>

    </v-card>
  </v-dialog>
</template>

<script>
  import FormToolbar from '../ui/FormToolbar.vue';
  import CargoTable from './CargoTable.vue';

  export default {
    name: 'CargoHandlingDialog',
    props: {
      value: Boolean,
      activity: {
        type: Object,
        required: true,
      },
      inboundCargo: Boolean,
      outboundCargo: Boolean,
      error: Boolean,
      onCloseClick: Function,
    },
    components: {
      FormToolbar,
      CargoTable,
    },
    data() {
      return {
        tab: '',
      };
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
    watch: {
      show(val) {
        if (!val) this.onCloseClick(this.activity);
      },
    },
  };
</script>

<style>

</style>
